import { css } from 'styled-components';
import token from 'styled-token';
import { VisuallyHiddenMixin } from './VisuallyHiddenMixin';

/** @class CarouselSkipLinkMixin */
/** @method */
export var CarouselSkipLinkMixin = function CarouselSkipLinkMixin(props) {
  return token({
    height: 'CarouselSkipLink.height',
    background: 'CarouselSkipLink.background',
    margin: 'CarouselSkipLink.margin',
    width: 'CarouselSkipLink.width'
  }, function (_ref) {
    var height = _ref.height,
      background = _ref.background,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width;
    return css(["", " &:focus{background-color:", ";display:block;line-height:", "px;text-align:center;clip:auto;clip-path:none;height:", "px;margin:", "px;overflow:visible;position:absolute;width:", ";z-index:10;}"], VisuallyHiddenMixin, background, height, height, margin, width);
  })(props);
};